import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getList, getCheckItemsByGroup, updateCIG, deleteCIG, addCIG, deleteCI, addCI, getAutonomousCheckItemFiles,
    addAutonomousCheckItemFiles,
    deleteAutonomousCheckItemFiles } from "../../store/actions/CheckItemGroupActions";
import moment from "moment";
import { getFormDataFromFiles, getSelectedFileNames } from "../../common";
import CheckItemGroup from "../../components/CheckItemGroup/CheckItemGroup";

export default function AutonomousCheckItemGroup() {
    const dispatch = useDispatch();
    const [initialRows, setInitialRows] = useState([]);
    let [rows, setRows] = useState([]);
    let [items, setItems] = useState([]);
    const [pageLoaded, setPageLoaded] = useState(false);
    const [startDate, setStartDate] = useState(moment(new Date()).format("YYYY-MM-DD"));
    const [endDate, setEndDate] = useState(moment(new Date()).format("YYYY-MM-DD"));
    const [CIGName, setCIGName] = useState("");
    const [CIGNote, setCIGNote] = useState("");

    const { itemGroupList, itemListByGroupId, isTaskUpdatedCheckItemGroup, autonomousCheckItemFiles } = useSelector(({ CheckItemGroup }) => CheckItemGroup);

    useEffect(() => {
        loadHandler();
    }, []);

    useEffect(() => {
        if (itemGroupList?.resultObject) {
            //resultObject
            setPageLoaded(true);
            setRows(Object.values(itemGroupList.resultObject));
            setInitialRows(cloneObject(Object.values(itemGroupList.resultObject)));
        }
    }, [itemGroupList]);

    // for check items by group id
    useEffect(() => {
        if (itemListByGroupId?.resultObject) {
            //resultObject
            setPageLoaded(true);
            setItems(Object.values(itemListByGroupId.resultObject));
        }
    }, [itemListByGroupId]);

    useEffect(() => {
        if (isTaskUpdatedCheckItemGroup) {
            loadHandler();
        }
    }, [isTaskUpdatedCheckItemGroup]);

    useEffect(() => {
        if (autonomousCheckItemFiles) {
            setCheckItemFiles(autonomousCheckItemFiles);
            setIsDocumentPopupOpen(true);
        }
    }, [autonomousCheckItemFiles]);

    const cloneObject = (obj) => {
        return JSON.parse(JSON.stringify(obj));
    };

    const loadHandler = () => {
        getCheckItemGroupList();
    };

    const onStartDateChangeHandler = (date) => {
        setStartDate(date);
    };

    const onEndDateChangeHandler = (date) => {
        setEndDate(date);
    };

    const NameHandler = (name) => {
        setCIGName(name);
    };

    const NoteHandler = (note) => {
        setCIGNote(note);
    };

    const setRowsFunction = (newRows) => {
        setRows(newRows);
    };

    const getCheckItemGroupList = () => {
        dispatch(getList(true));
    };

    const idSender = (rowId) => {
        dispatch(getCheckItemsByGroup(rowId));
    };

    const updateAddHandlerCIG = (row) => {
        let data = {};
        if (row.id !== "") {
            setStartDate(row.validityStartDate);
            setEndDate(row.validityEndDate);
            data = {
                name: row.name !== CIGName ? CIGName : row.name,
                note: row.note !== CIGNote ? CIGNote : row.note,
                validityStartDate: row.validityStartDate !== startDate ? startDate : row.validityStartDate,
                validityEndDate: row.validityEndDate !== endDate ? endDate : row.validityEndDate,
            };
            dispatch(updateCIG({ id: row.id, data }));
            if(CIGName === "" ){
                setCIGName(row.name);
            }
        } else {
            data = {
                name: CIGName,
                note: CIGNote,
                validityStartDate: startDate,
                validityEndDate: endDate,
            };
            dispatch(addCIG(data));
        }
    };

    const deleteCIHandler = (row) => {
        let data = {
            id: row.id,
            name: row.name,
            note: row.note,
        };
        dispatch(deleteCI(data.id));
    };

    const deleteCIGHandler = (row) => {
        let data = {
            id: row.id,
            name: row.name,
            note: row.note,
        };
        dispatch(deleteCIG(data.id));
    };

    const enableEditHandler = (row) => {
        setRows(cloneObject(initialRows))
        setCIGName(row.name);
        setCIGNote(row.note);
        setStartDate(row.validityStartDate);
        setEndDate(row.validityEndDate);
    };

    const [checkItemGroupId, setCheckItemGroupId] = useState(null);

    const handleCheckItemAdd = (name, note) => {
        let data = {
            groupId: checkItemGroupId,
            name: name,
            note: note,
        };
        dispatch(addCI(data));
    };

    const openCheckItemPopup = (id) => {
        setCheckItemGroupId(id);
    };

    // File Management
    const [checkItemFiles, setCheckItemFiles] = useState([]);
    const [checkItemIdForFileUpload, setCheckItemIdForFileUpload] = useState(0);
    const [checkItemIdForFileDelete, setCheckItemIdForFileDelete] = useState(0);
    const [isFileUploaderPopupOpen, setIsFileUploaderPopupOpen] = useState(false);
    const [isDocumentPopupOpen, setIsDocumentPopupOpen] = useState(false);

    const HandleDocumentPopupOpen = (id) => {
        setCheckItemIdForFileDelete(id);
        dispatch(getAutonomousCheckItemFiles(id));
    };

    const HandleFileUploaderPopupOpen = (id) => {
        setCheckItemIdForFileUpload(id);
        setIsFileUploaderPopupOpen(true);
    };

    const UploadFiles = (files) => {
        const formData = getFormDataFromFiles(files);
        const payload = {
            checkItemId: checkItemIdForFileUpload,
            data: formData,
        };
        console.log(payload);
        dispatch(addAutonomousCheckItemFiles(payload));
        setIsFileUploaderPopupOpen(false);
    };

    const DeleteAutonomousCheckItemFile = (selectedFiles) => {
        const selectedFileNames = getSelectedFileNames(selectedFiles);
        const payload = {
            checkItemId: checkItemIdForFileDelete,
            fileNames: selectedFileNames,
        };
        console.log(payload);
        dispatch(deleteAutonomousCheckItemFiles(payload));
        setIsDocumentPopupOpen(false);
    };

    return (
        <CheckItemGroup
            rows={rows}
            setRowsFunction={setRowsFunction}
            initialRows={initialRows}
            pageLoaded={pageLoaded}
            items={items}
            handleCheckItemAdd={handleCheckItemAdd}
            openCheckItemPopup={openCheckItemPopup}
            idSender={idSender}
            enableEditHandler={enableEditHandler}
            deleteCIHandler={deleteCIHandler}
            deleteCIGHandler={deleteCIGHandler}
            updateAddHandlerCIG={updateAddHandlerCIG}
            onStartDateChangeHandler={onStartDateChangeHandler}
            onEndDateChangeHandler={onEndDateChangeHandler}
            NameHandler={NameHandler}
            NoteHandler={NoteHandler}
            HandleFileUploaderPopupOpen={HandleFileUploaderPopupOpen}
            HandleDocumentPopupOpen={HandleDocumentPopupOpen}
            isFileUploaderPopupOpen={isFileUploaderPopupOpen}
            isDocumentPopupOpen={isDocumentPopupOpen}
            setIsFileUploaderPopupOpen={setIsFileUploaderPopupOpen}
            setIsDocumentPopupOpen={setIsDocumentPopupOpen}
            UploadFiles={UploadFiles}
            DeleteCheckItemFile={DeleteAutonomousCheckItemFile}
            checkItemFiles={checkItemFiles}
        ></CheckItemGroup>
    );
}
